module.exports = __webpack_public_path__ + "img/last-logon.ab474888.jpg";